import { Box, Button, IconButton, MenuItem, Snackbar, TextField, Typography } from '@mui/material';
import Header from '../../components/Header';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';
import { can } from '../../utils/permissions';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ExcursionDuplicate = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');
  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState({
    name: '',
    description: '',
    location: '',
    price: '',
    image: '',
    imageURL: '',
    country: '',
  });

  const [newImage, setNewImage] = useState(null);
  const [countryNames, setCountryNames] = useState([]);

  const token = localStorage.getItem('token');

  const getCountryNames = async () => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/countrynames`, { headers: { token } });
    const data = await res.json();
    setCountryNames(data);
  };

  const getExcursionDetails = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_APILINK}/excursion/${id}`, { headers: { token } });
      const data = await res.json();
      if (data.success && data.excursion) {
        setValues({
          name: data.excursion.ExcursionName,
          description: data.excursion.ExcursionDescription,
          location: data.excursion.ExcursionLocation,
          price: data.excursion.ExcursionPrice,
          image: data.excursion.ExcursionImage,
          imageURL: data.excursion.ExcursionImageURL,
          country: data.excursion.CountryName,
        });
      } else {
        navigate('/excursions');
      }
    } catch (error) {
      console.log(error);
      navigate('/excursions');
    }
  };

  useEffect(() => {
    getExcursionDetails();
    getCountryNames();
  }, []);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const imageHandler = (e) => {
    setNewImage(e.target.files[0]);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      ['clean'],
    ],
  };

  const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'color', 'background'];

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!values.name || !values.description || !values.location || (!values.price && can('prices.edit')) || !values.country) {
      setOpenToast(true);
      setToastmessage('Please fill all details');
      setLoading(false);
      return;
    }

    let imageName = values.image;

    if (newImage) {
      const formData = new FormData();
      formData.append('file', newImage);
      try {
        const imageRes = await fetch(`${process.env.REACT_APP_APILINK}/excursion/uploadimage`, {
          headers: { token },
          method: 'POST',
          body: formData,
        });
        const imageData = await imageRes.json();
        if (imageData.success) {
          imageName = imageData.image;
        } else {
          setOpenToast(true);
          setToastmessage(imageData.message || 'Image upload failed');
          setLoading(false);
          return;
        }
      } catch (error) {
        console.log(error);
        setOpenToast(true);
        setToastmessage('Image upload failed');
        setLoading(false);
        return;
      }
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_APILINK}/excursion/addexcursion`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json', token },
        body: JSON.stringify({ ...values, image: imageName }),
      });
      const data = await res.json();
      if (data.message) {
        setOpenToast(true);
        setToastmessage(data.message);
        if (data.success) {
          setTimeout(() => {
            navigate('/excursions');
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
      setOpenToast(true);
      setToastmessage('Error creating excursion');
    }

    setLoading(false);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenToast(false);
  };

  const action = (
    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  const currentImageSrc = newImage ? URL.createObjectURL(newImage) : values.imageURL || null;

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" rowGap="10px" flexWrap="wrap-reverse">
        <Header title="DUPLICATE EXCURSION" subtitle="Duplicate an existing excursion" />
        <Button
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            width: 'fit-content',
            fontSize: '14px',
            fontWeight: 'bold',
            padding: '10px 30px',
            '&:hover': { backgroundColor: colors.blueAccent[800] },
          }}
        >
          Go Back
        </Button>
      </Box>

      <form onSubmit={handleFormSubmit}>
        <Box style={{ display: 'grid', gap: '1.25rem', paddingBottom: '20px' }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Country"
            onChange={handleChange}
            value={values.country}
            name="country"
            select
          >
            {countryNames.map((c) => (
              <MenuItem key={c.CountryID} value={c.CountryName}>
                {c.CountryName}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Excursion Name"
            onChange={handleChange}
            value={values.name}
            name="name"
            required
          />

          <Box>
            <Typography variant="subtitle1" color={colors.grey[100]} mb={1}>
              Description *
            </Typography>
            <ReactQuill
              theme="snow"
              value={values.description}
              onChange={(content) => setValues((prev) => ({ ...prev, description: content }))}
              modules={modules}
              formats={formats}
              style={{ borderRadius: '4px', backgroundColor: '#293040' }}
            />
          </Box>

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Location"
            onChange={handleChange}
            value={values.location}
            name="location"
            required
          />

          <TextField
            fullWidth
            variant="filled"
            type="number"
            label="Price"
            onChange={handleChange}
            value={values.price}
            name="price"
            required={can('prices.edit')}
            disabled={!can('prices.edit')}
            helperText={can('prices.edit') ? undefined : 'You do not have permission to change prices'}
          />

          <Box>
            <Typography variant="h5" my="5px" px="5px" color={colors.grey[100]}>
              Excursion Image
            </Typography>
            <label
              htmlFor="file-input"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                padding: '15px',
                background: colors.primary[400],
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                borderRadius: '10px',
                width: '100%',
                maxWidth: '400px',
                aspectRatio: '16/9',
              }}
            >
              {currentImageSrc ? (
                <img
                  src={currentImageSrc}
                  alt="Excursion"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <>
                  <CloudUploadIcon fontSize="large" /> Upload Image
                </>
              )}
            </label>
            <input type="file" accept="image/*" onChange={imageHandler} name="image" id="file-input" hidden />
            {currentImageSrc && (
              <Typography variant="caption" sx={{ color: colors.grey[400], mt: '4px', display: 'block' }}>
                Click the image above to replace it
              </Typography>
            )}
          </Box>

          <Button
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              width: 'fit-content',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '10px 30px',
              '&:hover': { backgroundColor: colors.blueAccent[800] },
            }}
          >
            {loading ? 'Duplicating...' : 'Duplicate'}
          </Button>
        </Box>
      </form>

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default ExcursionDuplicate;
